import Vue from 'vue'

Vue.directive('per', {
  inserted: async function(el, binding) {
    const { name, showBut } = binding.value
    if (showBut.indexOf(name) === -1) {
      el.style.display = 'none'
    }
  }
})
